var React = require('react');

function Down (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/arrow/down"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Connection","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"mockup-03","transform":"translate(-885.000000, -222.000000)","fill":"#777777"},React.createElement("g",{"id":"icon/arrow/down","transform":"translate(877.000000, 212.000000)"},React.createElement("polygon",{"id":"Path-2-Copy-2","points":"12 15 16 10 8 10"}))))]);
}

Down.defaultProps = {"width":"8px","height":"5px","viewBox":"0 0 8 5","version":"1.1"};

module.exports = Down;

Down.default = Down;
